module.exports = __webpack_public_path__ + "static/media/ecommerce-illus.00bef7ee.png";